import getConfig from 'next/config';
export const APP_VERSION = process.env.APP_VERSION;
// KEY
export const API_KEY = process.env.APP_API_KEY || '';
export const PRIVATE_KEY =
    process.env.APP_PRIVATE_KEY || '882QcNXV4tUZbvAsjmFOHqNC1LpcBRKW';

// ENV
export const APP_ENV: string = process.env.APP_ENV || 'local';
export const IS_LOCAL: boolean = APP_ENV === 'local';
export const IS_DEVELOPMENT: boolean = APP_ENV === 'development';
export const IS_PRODUCTION: boolean = APP_ENV === 'production';

//URL
export const DOMAIN_NAME = process.env.APP_DOMAIN_NAME;
export const DOMAIN_MOBILE_URL =
    process.env.APP_DOMAIN_MOBILE_URL || 'localhost:3000';
export const API_URL = IS_PRODUCTION
    ? 'https://bs-api.baomoi.com/v1'
    : 'https://beta-bs-api.baomoi.com/v1';
export const API_URL_BM = IS_PRODUCTION
    ? 'https://w-api.baomoi.com/api/v1'
    : 'https://dev-w-api.baomoi.com/api/v1';
export const API_URL_BM_DEFAULT = IS_PRODUCTION
    ? 'https://w-api.baomoi.com/api/v1'
    : 'https://dev.baomoi.com/api/v1';
export const BASE_URL = IS_PRODUCTION
    ? 'https://baomoi.com'
    : IS_DEVELOPMENT
    ? 'https://dev.baomoi.com'
    : 'localhost:3000';
export const INTERNAL_URL = 'http://bscore-internal-api:8901/v1';
export const INTERNAL_SLAVE_URL = IS_PRODUCTION
    ? 'http://bscore-internal-slave-api:8901/v1'
    : INTERNAL_URL;
export const INTERNAL_LOG_URL = IS_PRODUCTION
    ? 'http://10.30.11.182:8809/api/v1'
    : API_URL;

export const HTTP_PROXY = IS_PRODUCTION
    ? 'http://10.60.28.99:81'
    : 'http://10.30.80.254:81';

export const assetPrefixPublic =
    getConfig().serverRuntimeConfig.ASSET_PREFIX_PUBLIC || '';
